import { render, staticRenderFns } from "./SystemInformation.vue?vue&type=template&id=0eb8f7be&scoped=true&"
import script from "./SystemInformation.vue?vue&type=script&lang=js&"
export * from "./SystemInformation.vue?vue&type=script&lang=js&"
import style0 from "./SystemInformation.vue?vue&type=style&index=0&id=0eb8f7be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb8f7be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eb8f7be')) {
      api.createRecord('0eb8f7be', component.options)
    } else {
      api.reload('0eb8f7be', component.options)
    }
    module.hot.accept("./SystemInformation.vue?vue&type=template&id=0eb8f7be&scoped=true&", function () {
      api.rerender('0eb8f7be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/SystemInformation.vue"
export default component.exports